import { supabase } from "./supabaseClient";

// The RPC derives the audience exclusively from auth.uid() and returns no
// feedback fields, so the browser never receives the user's feedback history.
export const hasCurrentUserSubmittedFeedback = async expectedUserId => {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;
  const sessionUserId = sessionData?.session?.user?.id;
  if (!sessionUserId || (expectedUserId && sessionUserId !== expectedUserId)) {
    const error = new Error("La sesión todavía no está lista para comprobar Feedback.");
    error.code = "FEEDBACK_SESSION_NOT_READY";
    throw error;
  }
  const { data, error } = await supabase.rpc("current_user_has_feedback");
  if (error) throw error;
  return data === true;
};
